<template>
    <div class="report">
        <div class="avatar">
            <div class="contianer dfx">
                <el-button class="go_back" @click="goBack">
                <img src="../assets/previous.svg" alt="返回上一级" />
                </el-button>
                <div class="column">测评历史 - {{ studentName }}</div>
            </div>
        </div>
        <div class="asstes contianer">
          <div class="item" v-for="item in evaluaList" :key="item.id">
            <div class="vatar">
              <el-avatar :size="56" :src="item.student_avatar"></el-avatar>
            </div>
            <div class="con">
              <div class="text">
                <div class="name"><span>姓名：</span>{{ item.student_nickname || item.student_name || '-' }}</div>
                <div class="num"><span>编号：</span>{{ item.evalua_number }}</div>
                <div class="num"><span>时间：</span>{{ item.evalua_time }}</div>
              </div>
              <div class="age">
                <div class="sex"><span>状态：</span>{{ item.status_text }}</div>
                <el-button type="primary" v-if="item.is_finish" @click="goReport(item)">
                  查看报告
                </el-button>
                <el-button type="primary" style="background: #32b12b;"
                  v-if="item.status === 2 || item.status === 9" @click="reEvaluate(item)">
                  重新测评
                </el-button>
              </div>
            </div>
          </div>
          <div class="item" v-if="loading || noMoreData" style="background: #f9dcdc;">
            <div v-if="loading" style="text-align: center;margin: 0 auto;">加载中...</div>
            <div v-if="noMoreData && !loading" style="text-align: center;margin: 0 auto;">没有更多数据！</div>
          </div>
          <div class="item" v-if="!loading && evaluaList.length === 0" style="text-align: center;">
            暂无测评记录
          </div>
        </div>
    </div>
</template>
<script>
import { getEvaluaHistory, userEditMultiple } from '@/api/app'
import { Loading } from 'element-ui'
export default {
  name: 'EvaluaHistory',
  data () {
    return {
      studentId: 0,
      studentName: '',
      page_no: 1,
      loading: false,
      noMoreData: false,
      evaluaList: [],
      fDatas: {}
    }
  },
  mounted () {
    this.studentId = this.$route.query.student_id
    this.studentName = this.$route.query.name || ''
    if (this.studentId) {
      this.fetchData()
    }
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    goReport (item) {
      this.$router.push('/previewreporthtml?evalua_number=' + item.evalua_number + '&sid=' + item.student_id)
    },
    reEvaluate (item) {
      this.$confirm('确定要重新测评吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const fData = userEditMultiple({ id: item.student_id, status: 5 })
        fData.then(() => {
          this.$message.success('已重置为等待测评')
          this.fetchData()
        }).catch(() => {
          this.$message.error('重新测评失败！')
        })
      }).catch(() => {})
    },
    async fetchData () {
      if (this.fDatas.count) {
        if (this.fDatas.count === this.evaluaList.length || this.fDatas.count < this.fDatas.page_size) {
          this.noMoreData = true
          return
        }
      }
      this.loading = true
      const loadingInstance = Loading.service({ fullscreen: true })
      try {
        this.fDatas = await getEvaluaHistory({
          student_id: this.studentId,
          page_no: this.page_no,
          page_size: 20
        })
        const newItems = this.fDatas.lists || []
        if (newItems.length === 0) {
          this.noMoreData = true
        } else {
          this.evaluaList = [...this.evaluaList, ...newItems]
          this.page_no++
        }
        if (!this.studentName && newItems.length > 0) {
          this.studentName = newItems[0].student_nickname || ''
        }
      } catch (e) {
        console.error('获取测评历史失败', e)
      } finally {
        loadingInstance && loadingInstance.close()
        this.loading = false
      }
    },
    handleScroll () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const windowHeight = window.innerHeight
      const documentHeight = document.documentElement.scrollHeight
      if (windowHeight === documentHeight) return
      if (scrollTop + windowHeight >= documentHeight - 10 && windowHeight !== documentHeight) {
        if (!this.noMoreData) {
          this.fetchData()
        }
      }
    }
  }
}
</script>
<style scoped>
.report {
  min-height: 100vh;
  background-color: #efefef;
  padding-bottom: 70px;
}
.report .avatar {
  width: 100%;
  background: linear-gradient(90deg, #ff9b00, #accd05);
  padding: 1rem 0;
}
.report .avatar .go_back {
  position: absolute;
  top: 0;
  left: 10px;
  background: transparent;
  border: none;
  padding: 0;
}
.report .avatar .go_back img {
  width: 1.25rem;
  height: 1.25rem;
}
.report .avatar .dfx {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.report .avatar .column {
  flex: 1;
  text-align: center;
  font-size: 1.13rem;
  font-weight: bold;
  color: #fff;
}
.asstes.contianer {
  max-width: 1024px;
  margin: 0 auto;
  padding: 5% 0 calc(5% + 68px);
}
@media (max-width: 1024px) {
  .asstes.contianer {
    max-width: 90%;
    margin: 0 auto;
  }
}
.item {
  border-radius: 1.13rem;
  background-color: #fff;
  padding: 1rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.item + .item {
  margin-top: 1.5rem;
}
.item .vatar {
  display: flex;
  align-items: center;
  position: relative;
  margin-right: 1.13rem;
}
.item .vatar .el-avatar {
  width: 5.06rem;
  height: 5.06rem;
}
.item .vatar .el-avatar img {
  width: 100%;
}
.item .con {
  flex: 1;
  padding-top: 0.8rem;
}
.item .con .text {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item .con .text .name {
  font-size: 1.13rem;
  font-weight: bold;
  line-height: 100%;
}
.item .con .text .name span {
  font-weight: normal !important;
}
.item .con .text .num {
  font-size: 1.13rem;
  font-weight: bold;
  line-height: 100%;
  padding-top: 0.2rem;
}
.item .con .text .num span {
  font-weight: normal !important;
}
.item .age {
  display: flex;
  justify-content: space-between;
  margin-top: 1.1rem;
  align-items: center;
}
.item .age .sex {
  font-size: 1.13rem;
  font-weight: bold;
  line-height: 100%;
  padding-top: 0.2rem;
}
.item .age .sex span {
  font-weight: normal !important;
}
.item .age .el-button {
  width: 7.63rem;
  height: 2rem;
  background: linear-gradient(0deg, #FF7200 6%, #FF9C00);
  border-radius: 1rem;
  padding: 0;
  border: none;
  font-size: 1rem;
  color: #fff;
  line-height: 2rem;
  margin-left: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/views/EvaluaHistory.vue